<template>
    <div @mousedown="mouseDownCallback($event)" @click="callback($event)" class="primary-button" :class="{'disabled': disabled, 'inverse': isInverse}" tabindex="-1" role="button">
      <slot></slot>
	  <div class="loading-wrapper" v-if="loading">
      	<div class="loading-spinner"></div>
	  </div>
    </div>
</template>

<script>
    module.exports = {
      props: {
        type: String,
        disabled: Boolean,
        loading: Boolean,
        isInverse: {
          type: Boolean,
          default: false
        }
      },
      methods: {
        callback: function(e) {
          if (!this.disabled) {
            this.$emit('click', e);
          }
        },
        mouseDownCallback: function(e) {
           if (!this.disabled) {
            this.$emit('mousedown', e);
          } 
        }
      }
    }
</script>

<style scoped lang="scss">

    @import './variables';

    .primary-button {
        position: relative;
        color: $white;
        background-color: $primary-blue;
        font-family: $text-font;
        font-size: 0.9rem;
        border: 2px solid #333333;
        border-radius: 30px;
        height: 46px;
        font-weight: bold;
        line-height: 1;
        display: inline-block;
        padding: 0.85rem 1.12rem;
        cursor: pointer;
        margin: 0.85rem 0;

        &:hover {
          background: $primary-blue-hover;
        }
        &.disabled {
            pointer-events: none;
            opacity: 0.6;
        }

        &.danger {
            background-color: #ff4949;
            color: #fff;
        }
        &.success {
            background-color: #13ce66;
            color: #fff;
        }
        &.info {
            background-color: #50bfff;
            color: #fff;
        }
        &.inverse {
          background: #ffffff;
          color: $primary-dark-blue;
        }
		.loading-wrapper {
		  position: absolute;
		  left: 50%;
		  top: 50%;
		  transform: translate(-50%, -50%);
		}
    }

</style>
